import { FormView, RegistrationFlow } from "./application-flow.js";
const presetMap = {
  // default behavior when no form view and registration flow is set is RegistrationFlow.LightAccount and FormView.TwoStep
  inline: {
    view: "inline"
  },
  modal: {
    view: "modal"
  },
  ["account-activation"]: {
    view: "inline",
    formView: FormView.TwoStep
  },
  ["kmc-register"]: {
    view: "inline",
    formView: FormView.OneStep,
    registrationFlow: RegistrationFlow.FullAccount
  },
  ["reset-password"]: {
    view: "inline",
    formView: FormView.TwoStep
  },
  ["one-step-modal-full"]: {
    view: "modal",
    formView: FormView.OneStep,
    registrationFlow: RegistrationFlow.FullAccount
  },
  ["subscription-inline"]: {
    view: "inline",
    formView: FormView.OneStep,
    registrationFlow: RegistrationFlow.LightAccount,
    translation: "subscription-inline"
  },
  ["checkout-inline"]: {
    view: "inline",
    formView: FormView.TwoStep,
    translation: "checkout-inline"
  },
  _cusTransModal: {
    view: "modal",
    translation: "test-preset"
  },
  _fullAccountInline: {
    view: "inline",
    formView: FormView.OneStep,
    registrationFlow: RegistrationFlow.FullAccount
  },
  _fullAccountModal: {
    view: "modal",
    formView: FormView.OneStep,
    registrationFlow: RegistrationFlow.FullAccount
  },
  _subscriptionModal: {
    view: "modal",
    formView: FormView.OneStep,
    registrationFlow: RegistrationFlow.LightAccount
  },
  ["invite-a-friend"]: {
    view: "inline",
    translation: "invite-a-friend"
  },
  ["confirmed-app"]: {
    view: "inline",
    isAuthProvider: true,
    formView: FormView.TwoStep,
    registrationFlow: RegistrationFlow.FullAccount,
    translation: "apps"
  },
  ["adidas-app"]: {
    view: "inline",
    isAuthProvider: true,
    formView: FormView.TwoStep,
    registrationFlow: RegistrationFlow.FullAccount,
    translation: "apps"
  },
  ["re-authentication"]: {
    view: "modal"
  },
  ["adidas-running"]: {
    view: "inline",
    isAuthProvider: true,
    translation: "apps"
  },
  ["login-method"]: {
    view: "modal",
    formView: FormView.TwoStep
  }
};
export {
  presetMap
};
//# sourceMappingURL=presets.js.map
